import globals from '../../styles/globals';

export default (theme) => ({
    ...globals(theme),
    notFoundPage: {
    }
});
